import React from "react";
import { ShieldCheck, Leaf } from "lucide-react";

/** Two fixed brand pillars, reused across the site. Bronze accent. */
export const PillarBadges = ({ align = "start", className = "" }) => (
  <div className={`flex flex-wrap gap-3 items-center ${align === "center" ? "justify-center" : ""} ${className}`}>
    <span className="inline-flex items-center gap-2 text-[10px] tracking-widest2 uppercase text-bronze border border-brand-border bg-brand-surface px-3 py-1.5">
      <ShieldCheck size={12} /> Woman-safe · Inclusive
    </span>
    <span className="inline-flex items-center gap-2 text-[10px] tracking-widest2 uppercase text-bronze border border-brand-border bg-brand-surface px-3 py-1.5">
      <Leaf size={12} /> Quiet green fleet
    </span>
  </div>
);

export default PillarBadges;
